import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<ellipse cx=\"100\" cy=\"120\" rx=\"32\" ry=\"22\"></ellipse><path d=\"M80 110 40 90l-10 20 20 6ZM120 110l40-20 10 20-20 6Z\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"6\" d=\"m80 120-30 20M80 125l-32 33M120 120l30 20M120 125l32 33\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"10\" d=\"M100 140q10 20 30 22 22-2 22-24 0-14-14-14\"></path><path d=\"M132 116h16l-8-16z\"></path>", 5)
  ]))]))
}
export default { render: render }